/*
 * @Date: 2022-04-13 18:11:56
 * @LastEditTime: 2022-11-29 16:47:27
 * @Description:　共通 base64ファイルを取得
 */
import { API_FILEMANAGE_GetFileData } from "@/api/Modules/CM04/STDSCM04C00.js";
import _ from "lodash";

function base64ToBlob(base64, type = "application/octet-stream") {
  const binStr = window.atob(base64);
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[i] = binStr.charCodeAt(i);
  }
  return new Blob([arr], { type: type });
}
/**
 * ファイルをダウンロード
 * @param {*} dataUrl - ファイルソース
 * @param {*} filename ファイル名
 **/
const download = (dataUrl, filename) => {
  let link = document.createElement("a");
  link.href = dataUrl;
  link.download = filename;
  link.click();
  link = null;
};
/**
 * ファイルをダウンロード(ファイル名指定)
 * @param {*} dataUrl - ファイルソース
 * @param {*} filename ファイル名
 * @param {*} localFileName ファイル名
 **/
const downloadAsOtherName = (dataUrl, filename, localFileName) => {
  let link = document.createElement("a");
  link.href = dataUrl;
  link.download = localFileName == "" ? filename : localFileName;
  link.click();
  link = null;
};

/**
 * base64 ファイルを取得API
 * @param {*} filename ファイル名
 **/
const getFileBase64Data = (fileName, uniqueKey) => {
  return API_FILEMANAGE_GetFileData({
      FileName: fileName,
      uniqueKey: uniqueKey,
    })
    .then((response) => {
      const objURL = encodeURI(response.fileData);
      return {
        ...response,
        objURL,
      };
    });
};
/**
 * base64 ファイルを取得
 * @param {*} filename ファイル名
 **/
const transFormFileBase64Data = (response) => {
  const objURL = encodeURI(response.fileData);
  return {
    ...response,
    objURL,
  };
};

/**
 * base64 ファイルを取得、指定したファイル名でのダウンロードAPI
 * @param {*} filename ファイル名
 * @param {*} localFileName ダウンロードファイル名
 **/
const downloadAsOtherNameApi = async (res, fileName) => {
  const response = transFormFileBase64Data(res);
  if (response?.result == "0000") {
    const file = `data:application/octet-stream;base64, ${response.objURL}`;
    download(file, fileName);
  }
  return new Promise((resolve, reject) => {
    resolve(response);
  });
};

/**
 * base64 code取得API
 * @param {*} filename ファイル名
 **/
const getPDFApi = async (res) => {
  const response = transFormFileBase64Data(res);
  if (response?.result == "0000" || response?.result == "0001" ) {
    const blob = base64ToBlob(response.objURL, "application/pdf");
    const file = URL.createObjectURL(blob);
    return {
      ...response,
      objURL: file,
    };
  }

  return new Promise((resolve, reject) => {
    resolve(response);
  });
};

/**
 * base64 code取得, 新しいtabを開く　API
 * @param {*} filename ファイル名
 * @param {*} filename true:new tab| false: new window
 **/
const openPDFApi = async (fileName, isTab = true) => {
  const response = await transFormFileBase64Data(fileName);
  if (response?.result == "0000") {
    const blob = base64ToBlob(response.objURL, "application/pdf");
    const file = URL.createObjectURL(blob);
    let pdfWindow = isTab
      ? window.open("")
      : window.open(
          "",
          "",
          "width=1240,height=760,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no"
        );
    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='${file}'></iframe>`
    );
  }

  return response;
};

export { getPDFApi, openPDFApi, transFormFileBase64Data, downloadAsOtherNameApi };
